import { AgChartOptions } from 'ag-charts-community'

import { capitalise } from '@fortem-monorepo/js-utilities'
import { CustomAgChart } from '@fortem-monorepo/react-ag'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { fundLevel } from '@/react-query/queries/ic-report/hooks'

export interface FundLevelScenarioChartProps extends ICReportChartPrimitive {}

export const FundLevelScenarioChart: React.FC<FundLevelScenarioChartProps> = ({
  params,
  options,
}) => {
  const query = fundLevel.useHistoricalEventsNew(params)
  const data = query.data

  const titleList = (data?.investment_bucket_ls ?? []).map((str) => capitalise(str))

  const mergedOptions: AgChartOptions<NonNullable<typeof data>['data'][number]> = {
    height: 500,
    title: {
      text: titleList.join(', '),
    },
    data: data?.data,
    series: [
      {
        type: 'bar',
        xKey: 'shock_name',
        yKey: 'return_tmo',
        yName: `${titleList.join(' + ')} T-1`,
      },
      {
        type: 'bar',
        xKey: 'shock_name',
        yKey: 'return_t',
        yName: `${titleList.join(' + ')} T`,
      },
    ],
    axes: [
      {
        type: 'category',
        position: 'bottom',
        paddingInner: 0.5,
      },
      {
        type: 'number',
        position: 'left',
        interval: {
          minSpacing: 20,
        },
        label: {
          formatter: function (params) {
            return `${(params?.value * 100)?.toFixed(2)}%`
          },
        },
      },
    ],
    ...options,
  }
  return <CustomAgChart options={mergedOptions} />
}
